import React from "react";
import RBModal from "react-bootstrap/Modal";
import type { ModalProps } from "react-bootstrap/Modal";

const joinClasses = (
	...classes: Array<string | undefined | null | false>
): string => {
	return classes.filter(Boolean).join(" ");
};

type ThemedModalComponent = React.ForwardRefExoticComponent<
	ModalProps & React.RefAttributes<HTMLDivElement>
> & {
	Header: React.FC<React.ComponentProps<typeof RBModal.Header>>;
	Body: React.FC<React.ComponentProps<typeof RBModal.Body>>;
	Footer: React.FC<React.ComponentProps<typeof RBModal.Footer>>;
	Title: React.FC<React.ComponentProps<typeof RBModal.Title>>;
};

const ThemedModal = React.forwardRef<HTMLDivElement, ModalProps>(
	(
		{
			contentClassName,
			dialogClassName,
			backdropClassName,
			children,
			...props
		},
		ref,
	) => {
		return (
			<RBModal
				ref={ref}
				contentClassName={joinClasses("trc-modal", contentClassName)}
				dialogClassName={joinClasses("trc-modal-dialog", dialogClassName)}
				backdropClassName={joinClasses(
					"trc-modal-backdrop",
					backdropClassName,
				)}
				{...props}
			>
				{children}
			</RBModal>
		);
	},
) as ThemedModalComponent;

ThemedModal.displayName = "ThemedModal";

ThemedModal.Header = ({ className, ...props }) => {
	return <RBModal.Header className={joinClasses("trc-modal__header", className)} {...props} />;
};

ThemedModal.Body = ({ className, ...props }) => {
	return <RBModal.Body className={joinClasses("trc-modal__body", className)} {...props} />;
};

ThemedModal.Footer = ({ className, ...props }) => {
	return <RBModal.Footer className={joinClasses("trc-modal__footer", className)} {...props} />;
};

ThemedModal.Title = ({ className, ...props }) => {
	return <RBModal.Title className={joinClasses("trc-modal__title", className)} {...props} />;
};

export default ThemedModal;
export type { ModalProps };
